import React from 'react';
import Amc8Exams from '../Amc8Exams';
import FinraSieExams from '../FinraSieExams';
import FinraS7Exams from '../FinraS7Exams';
import FinraS63Exams from '../FinraS63Exams';
import FinraS65Exams from '../FinraS65Exams';
import FinraS66Exams from '../FinraS66Exams';
import GreExams from '../GreExams';

const EXAM_SLUG_MAP = {
  'amc-8': Amc8Exams,
  gre: GreExams,
  'finra-sie': FinraSieExams,
  'finra-series-7': FinraS7Exams,
  // TODO(finra-series-6)
  'finra-series-63': FinraS63Exams,
  'finra-series-65': FinraS65Exams,
  'finra-series-66': FinraS66Exams,
};

const TakeExams = (props) => {
  const { currentUser, product, disabled } = props;
  const { slug: productSlug } = product;

  const ExamsComponent = EXAM_SLUG_MAP[productSlug];
  if (!ExamsComponent) {
    return <div>TODO: {product.slug}</div>;
  }

  return (
    <ExamsComponent currentUser={currentUser} product={product} disabled={disabled} />
  );
};

export default TakeExams;
